export function SettingsSectionNav({ sections, activeSection, setActiveSection }) {
  return (
    <nav className="md:w-56 shrink-0 border-b md:border-b-0 md:border-r border-gray-100 p-3 md:p-4">
      <div className="flex md:flex-col gap-1 overflow-x-auto md:overflow-visible">
        {sections.map((section) => {
          const Icon = section.icon;
          const isActive = activeSection === section.id;

          return (
            <button
              key={section.id}
              onClick={() => setActiveSection(section.id)}
              className={`
                flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap transition-all
                ${
                  isActive
                    ? "bg-indigo-50 text-indigo-600"
                    : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                }
              `}
            >
              <Icon
                size={18}
                className={isActive ? "text-indigo-600" : "text-gray-400"}
              />
              {section.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
